export const SNIPPET_SALT = 'someStaticTextThatIsActuallySomewhatLong. It does not really matter that much'
